import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./banner.scss";
function Banner() {
  return (
    <>
      <div className="banner-container">
        {/* <img src={banner1} {"assets/img/banner-1.jpg"} /> */}
        <OwlCarousel items={1} className="owl-theme" loop nav autoplay ={true} >
          <div>
            <img className="img" alt="banner-1" src={"assets/img/banner-1.jpg"} />
          </div>
          <div>
            <img className="img" alt="banner-2" src={"assets/img/banner-2.jpg"} />
          </div>
          <div>
            <img className="img" alt="banner-3" src={"assets/img/banner-3.jpg"} />
          </div>
          
        </OwlCarousel>
      </div>
    </>
  );
}

export default Banner;
